export default __webpack_public_path__ + "static/media/lining.65d4294d.png";